module.exports = __webpack_public_path__ + "static/media/eve-btc.84c9777f.svg";